export enum BalanceTypes {
  ACCOUNT_SUMMARY = "accountSummary",
  CASE_BALANCE = "caseBalance",
}

export enum CourtSentenceDates {
  DUE_DATE = "dueDate",
  LIMIT_DATE = "limitDate",
}
